import React from 'react';

/*
 * errors stemming from react-hook-form and rendered through
 * ErrorMessage component are formatted as 'messages'
 * message = { [validation type]: errorText }
 *
 *
 */
const Errors = ({ messages, isSpan }) => {
  return (
    <>
      {isSpan ? (
        <>
          {messages &&
            Object.entries(messages).map(([type, message]) => (
              <div key={type} className='errors'>
                <span>{message}</span>
              </div>
            ))}
        </>
      ) : (
        <div className='errors'>
          <ul>
            {messages &&
              Object.entries(messages).map(([type, message]) => (
                <React.Fragment key={type}>
                  {Array.isArray(message) ? (
                    message.map((text) => <li key={text}>{text}</li>)
                  ) : (
                    <li key={type}>
                      {typeof message === 'string' ? message : 'Unknown Error'}
                    </li>
                  )}
                </React.Fragment>
              ))}
          </ul>
        </div>
      )}
    </>
  );
};

export default Errors;
